export const getCSSVariableValue = (variableName: string): string => {
  return window.getComputedStyle(document.body).getPropertyValue(variableName)
}
